<section class="card h-100" aria-live="polite">
  <header class="card-header">
    <div>
      <h3 class="card-title">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ title }}</h3>
      @if (subtitle) { <div class="text-secondary small">{{ subtitle }}</div> }
    </div>
  </header>

  @if (error) {
    <div class="widget-error m-3"><strong>Widget query error</strong><span>{{ error }}</span></div>
  } @else if (loading) {
    <div class="widget-loading m-3"><span class="spinner-border spinner-border-sm"></span>Loading records…</div>
  } @else if (rows.length === 0) {
    <div class="empty py-4"><p class="empty-title">{{ emptyText }}</p></div>
  } @else {
    <div class="table-responsive">
      @if (showAccountTypeDescription) {
      <table class="table table-vcenter  table-sm">
        <thead><tr><th>Account type</th><th>Description</th><th class="text-end">Balance</th></tr></thead>
        <tbody>
          @for (group of accountTypeGroups; track group.label) {
            <tr class="account-type-heading fw-semibold"><td colspan="3">{{ group.label }}</td></tr>
            @for (row of group.rows; track row['account_type']) {
              <tr><td class="ps-4">{{ row['account_type'] }}</td><td class="text-secondary">{{ accountTypeDescription(row['account_type']) }}</td><td class="text-end">{{ formatValue(row['balance'], { key: 'balance', label: 'Balance', format: 'currency' }) }}</td></tr>
            }
            <tr class="fw-semibold"><td colspan="2">{{ group.label }} subtotal</td><td class="text-end">{{ formatValue(group.total, { key: 'balance', label: 'Balance', format: 'currency' }) }}</td></tr>
          }
        </tbody>
        <tfoot><tr class="fw-bold"><td colspan="2">Net of all account types (debits less credits)</td><td class="text-end">{{ formatValue(accountTypeNet, { key: 'balance', label: 'Balance', format: 'currency' }) }}</td></tr></tfoot>
      </table>
      } @else {
      <table class="table table-vcenter table-sm">
        <thead>
          <tr>
            @for (column of columns; track column.key) {
              <th [class.text-center]="column.align === 'center'" [class.text-end]="column.align === 'end'">{{ column.label }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track $index) {
            <tr>
              @for (column of columns; track column.key) {
                <td [class.text-center]="column.align === 'center'" [class.text-end]="column.align === 'end'">
                  {{ formatValue(row[column.key], column) }}
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      }
    </div>
  }
</section>
